import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const hiStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'WhatsApp पर आमंत्रित करें',
  NLSWhatsappInviteDialogTitle: 'WhatsApp पर आमंत्रित करें',
  NLSWhatsappInviteDialogCopy: 'लिंक कॉपी करें',
  NLSWhatsappInviteDialogShare: 'साझा करें',
  NLSWhatsappSendFromMineAction: 'मेरे WhatsApp से भेजें',
  NLSWhatsappSendFromMineText: 'नमस्ते {name}, यह {workspace} से {sender} है।',
  NLSWhatsappSlipQrCaption: 'WhatsApp पर हमसे चैट करें',
  NLSWhatsappChipLinked: 'WhatsApp लिंक है',
  NLSWhatsappChipNotYet: 'WhatsApp: अभी नहीं',
  NLSWhatsappChipStopped: 'WhatsApp: रुका हुआ',
  NLSEduAnnouncementSendWhatsappAction: 'WhatsApp पर भेजें',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'WhatsApp पर भेजें',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'भेजें',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: '{n} अभिभावकों को भेजा जाएगा',
  NLSEduAnnouncementSendWhatsappSummaryCredits: '{n} अभिभावकों को भेजा जाएगा · लगभग {credits} क्रेडिट',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'आपकी योजना की सीमा के तहत निःशुल्क',
  NLSEduAnnouncementSendWhatsappReasonOff: 'इस वर्कस्पेस के लिए WhatsApp अक्षम है।',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'सेटिंग्स में व्यवस्थापक घोषणाएं भेजना बंद है।',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'सत्यापित फ़ोन सहमति वाला कोई अभिभावक नहीं मिला।',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'अपर्याप्त क्रेडिट के कारण WhatsApp भेजना रुका हुआ है।',
  NLSEduAnnouncementSentWhatsappCount: 'WhatsApp पर {count} लोगों को भेजा गया',
  NLSCommonRailPageShellSidecarSheet: "विवरण पैनल",
  NLSCommonActionBackToWorkspace: 'वर्कस्पेस पर लौटें',
  NLSCommonActionBack: 'वापस',
  NLSCommonActionCancel: 'रद्द करें',
  NLSCommonActionContinue: 'जारी रखें',
  NLSCommonActionSignOut: 'साइन आउट',
  NLSCommonActionRetryLoadingWorkspaces: 'वर्कस्पेस फिर लोड करें',
  NLSCommonActionRetrying: 'फिर कोशिश...',
  NLSCommonActionDownload: 'डाउनलोड',
  NLSCommonActionOpen: 'खोलें',
  NLSCommonActionReloadThisTab: 'यह टैब री लोड करें',
  NLSCommonActionMarkUpInDesign: 'Design में मार्क करें',
  NLSCommonAriaAccessDenied: 'पहुंच रोकी गई',
  NLSCommonAriaClosePreview: 'प्रीव्यू बंद करें',
  NLSCommonAriaConnectionStatus: 'कनेक्शन स्थिति',
  NLSCommonAriaPreviewAttachment: '{label} का प्रीव्यू',
  NLSCommonEmptyNoActions: 'कोई एक्शन नहीं',
  NLSCommonEmptyNoOptions: 'कोई विकल्प नहीं',
  NLSCommonErrorGeneric: 'कुछ गलत हुआ।',
  NLSCommonInputSearchPlaceholder: 'खोजें',
  NLSCommonInputSearchEllipsisPlaceholder: 'खोजें…',
  NLSCommonInputSearchOptionsPlaceholder: 'विकल्प खोजें',
  NLSCommonInputSelectPlaceholder: 'चुनें',
  NLSCommonInputSelectEllipsisPlaceholder: 'चुनें…',
  NLSCommonStatusApi: 'API',
  NLSCommonStatusLoading: 'लोड हो रहा है',
  NLSCommonLanguageAriaLabel: 'ऐप भाषा',
  NLSCommonLanguageLabel: 'भाषा',
  NLSCommonAccessDeniedDefaultMessage: 'आपकी खाता भूमिका इस क्षेत्र तक नहीं पहुंच सकती।',
  NLSCommonAccessDeniedTitle: 'पहुंच रोकी गई',
  NLSCommonConnectivityDescription: 'पिछला अनुरोध विफल हुआ क्योंकि यह डिवाइस ऑफलाइन लगता है। फिर से कनेक्ट करें और वही कार्रवाई दोहराएं। आपका मौजूदा वर्कस्पेस नीचे खुला रहेगा।',
  NLSCommonConnectivityEyebrow: 'कनेक्शन रुका',
  NLSCommonConnectivityRequestPaused: 'अनुरोध रुका',
  NLSCommonConnectivityTitle: 'Timelining नेटवर्क तक नहीं पहुंच सका।',
  NLSCommonPreviewAttachmentUnavailable: 'अटैचमेंट उपलब्ध नहीं।',
  NLSCommonPreviewFormatUnavailable: 'इस फॉर्मेट का प्रीव्यू यहां उपलब्ध नहीं है। आप मूल फाइल खोल या डाउनलोड कर सकते हैं।',
  NLSCommonPreviewKindAsset: 'एसेट',
  NLSCommonPreviewKindAudio: 'ऑडियो',
  NLSCommonPreviewKindDocument: 'दस्तावेज',
  NLSCommonPreviewKindFile: 'फाइल',
  NLSCommonPreviewKindImage: 'इमेज',
  NLSCommonPreviewKindLink: 'लिंक',
  NLSCommonPreviewKindSpreadsheet: 'शीट',
  NLSCommonPreviewKindTimelineItem: 'टाइमलाइन आइटम',
  NLSCommonPreviewKindVideo: 'वीडियो',
  NLSCommonPreviewPreparingText: 'टेक्स्ट प्रीव्यू तैयार हो रहा है...',
  NLSCommonPreviewTextBlocked: 'इस फाइल का टेक्स्ट प्रीव्यू ब्लॉक है। मूल फाइल खोलें या डाउनलोड करें।',
  NLSCommonPreviewTextTruncated: 'प्रीव्यू छोटा किया गया',
  NLSCommonTabErrorBody: 'ऐप का बाकी हिस्सा ठीक है। नीचे के टैब से आगे बढ़ें, या इस टैब को फिर से लोड करें।',
  NLSCommonTabErrorTitle: 'इस टैब में दिक्कत',
  NLSAuthEyebrowCloudWorkspace: 'क्लाउड वर्कस्पेस',
  NLSAuthEyebrowHelperAccess: 'हेल्पर एक्सेस',
  NLSAuthTitleCloudWorkspace: 'अपने लक्ष्य मैप करें। या अपनी टीम के।',
  NLSAuthTitleHelperPhone: 'फोन से साइन इन करें।',
  NLSAuthActionCheckSession: 'सेशन जांचें',
  NLSAuthActionContinueGoogle: 'Google से जारी रखें',
  NLSAuthActionOpeningGoogle: 'Google खुल रहा है...',
  NLSAuthActionSendOtp: 'OTP भेजें',
  NLSAuthActionSendingOtp: 'OTP भेज रहे हैं...',
  NLSAuthActionVerifySignIn: 'जांचें और साइन इन',
  NLSAuthActionVerifying: 'जांच हो रही है...',
  NLSAuthActionUseDifferentNumber: 'दूसरा नंबर',
  NLSAuthFieldPhoneNumber: 'फोन नंबर',
  NLSAuthFieldVerificationCode: 'कोड',
  NLSOnboardingEyebrowNewSpace: 'नई जगह तैयार है',
  NLSOnboardingTitleBegin: 'आप कहां से शुरू करना चाहेंगे?',
  NLSOnboardingPersonalTitle: 'पर्सनल स्पेस',
  NLSOnboardingActionLaunchPersonal: 'पर्सनल स्पेस खोलें',
  NLSOnboardingTeamTitleCreate: 'टीम वर्कस्पेस',
  NLSOnboardingActionExploreTeam: 'टीम विकल्प देखें',
  NLSOnboardingTabInvites: 'इनवाइट',
  NLSOnboardingTabDiscover: 'डिस्कवर',
  NLSOnboardingTabCreateNew: 'नया बनाएं',
  NLSShellRailSectionBoard: 'बोर्ड',
  NLSShellRailSectionControls: 'कंट्रोल',
  NLSShellRailDays: 'दिन',
  NLSShellRailPersonalWallet: 'पर्सनल वॉलेट',
  NLSShellRailTileDashboard: 'डैशबोर्ड',
  NLSShellRailTileCalendar: 'कैलेंडर',
  NLSShellRailTileMembers: 'मेंबर',
  NLSShellRailTileSettings: 'सेटिंग्स',
  NLSShellRailTileNotifications: 'सूचनाएं',
  NLSShellRailTileLogOut: 'लॉग आउट',
  NLSOpsRequestKindReliefNeeded: 'बदली की आवश्यकता',
  NLSOpsRequestKindIncident: 'घटना',
  NLSOpsRequestKindClientComplaint: 'ग्राहक की शिकायत',
  NLSOpsRequestKindSupplyRequest: 'आपूर्ति अनुरोध',
  NLSOpsRequestKindPm: 'निवारक रखरखाव',
  NLSOpsRequestKindCalibration: 'अंशांकन',
  NLSOpsReliefNeededTitle: 'राहत की आवश्यकता: {placeName} पर {roleLabel} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'साइट और शिफ्ट के अनुसार ड्यूटी पोस्ट · अनुपस्थिति पर राहत अनुरोध बनता है',
  NLSOpsSitesSelectSite: 'साइट चुनें',
  NLSOpsSitesDay: 'दिन',
  NLSOpsSitesSelectShift: 'शिफ्ट चुनें',
  NLSOpsSitesPostsBoardTitle: 'पोस्ट और राहत',
  NLSOpsSitesColPost: 'पोस्ट',
  NLSOpsSitesColNeeds: 'आवश्यकता',
  NLSOpsSitesColOnDuty: 'ड्यूटी पर',
  NLSOpsSitesColState: 'स्थिति',
  NLSOpsSitesStateCovered: 'कवर किया गया',
  NLSOpsSitesStateShort: 'कमी',
  NLSOpsSitesStateReliefNeeded: 'राहत की आवश्यकता',
  NLSOpsSitesStateReliefAssigned: 'राहत सौंपी गई',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'अनुपस्थित',
  NLSOpsSitesReliefInbox: 'राहत इनबॉक्स',
  NLSOpsSitesReliefFootnote: 'उपस्थिति में अनुपस्थिति स्वचालित रूप से RELIEF_NEEDED उठाती है और कवरेज की चेतावनी देती है (A6)।',
  NLSOpsSitesFreeCandidates: 'उपलब्ध उम्मीदवार:',
  NLSOpsSitesOffToday: 'आज छुट्टी पर',
  NLSOpsSitesAssignBtn: 'सौंपें',
  NLSOpsSitesAssignCandidateBtn: '{name} को सौंपें',
  NLSOpsSitesAssignDialogTitle: 'राहत कर्मी सौंपें',
  NLSOpsSitesPrintPostSheet: 'पोस्ट शीट प्रिंट करें',
  NLSOpsSitesNoPosts: 'इस साइट के लिए कोई ड्यूटी पोस्ट कॉन्फ़िगर नहीं है।',
  NLSOpsSitesNoReliefNeeded: 'किसी राहत की आवश्यकता नहीं है।',
  NLSOpsSitesNoSites: 'कोई क्लाइंट साइट नहीं मिली।',
  NLSOpsSitesNoShifts: 'कोई शिफ्ट उपलब्ध नहीं है।',
  NLSOpsSitesPostSheetTitle: 'पोस्ट शीट · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'राहत नहीं सौंप सकते: अनुरोध अब खुला नहीं है।',
  NLSOpsSitesErrorOnLeave: 'राहत नहीं सौंप सकते: व्यक्ति स्वीकृत अवकाश पर है।',
  NLSOpsSitesErrorDoubleBooked: 'राहत नहीं सौंप सकते: व्यक्ति पहले से ही इस शिफ्ट में तैनात है।',
  NLSOpsSitesErrorRoleCeiling: 'राहत नहीं सौंप सकते: सदस्य की भूमिका सीमा ड्यूटी कार्यभार रोकती है।',
  NLSOpsSitesErrorGeneric: 'राहत सौंपने में विफल।',
  NLSOpsSitesErrorNotFound: 'रिकॉर्ड या अनुरोध नहीं मिला।',
  NLSOpsSitesErrorMissingAttributes: 'अनुरोध में आवश्यक राहत विशेषताएँ अनुपलब्ध हैं।',
  NLSOpsSitesErrorInactivePerson: 'राहत नहीं सौंप सकते: व्यक्ति कार्यक्षेत्र में निष्क्रिय है।',
  NLSOpsRequestsUnassigned: 'असाइन नहीं किया गया',
  NLSOpsRequestsDetailUnassigned: 'असाइन नहीं किया गया',
  NLSOpsSitesIncidentsSubtitle: 'घटनाएं (प्रतिबंधित) · ग्राहक शिकायतें · आपूर्ति अनुरोध · पर्यवेक्षक साइट ऑडिट',
  NLSOpsSitesIncidentsTitle: 'घटनाएं',
  NLSOpsSitesRestrictedTag: 'प्रतिबंधित',
  NLSOpsSitesAuditScoresTitle: 'साइट ऑडिट स्कोर',
  NLSOpsSitesSupervisorRegisterTag: 'पर्यवेक्षक रजिस्टर',
  NLSOpsSitesColSite: 'साइट',
  NLSOpsSitesColLastAudit: 'अंतिम ऑडिट',
  NLSOpsSitesColScore: 'स्कोर',
  NLSOpsSitesRecordAuditBtn: 'ऑडिट रिकॉर्ड करें',
  NLSOpsSitesComplaintsSupplyTitle: 'शिकायतें और आपूर्ति अनुरोध',
  NLSOpsSitesNoIncidents: 'कोई घटना दर्ज नहीं है।',
  NLSOpsSitesNoComplaintsSupply: 'कोई शिकायत या आपूर्ति अनुरोध नहीं है।',
  NLSOpsSitesNoAudits: 'कोई साइट ऑडिट दर्ज नहीं है।',
  NLSOpsSitesNoAuditTemplate: 'कोई पर्यवेक्षक साइट ऑडिट टेम्पलेट कॉन्फ़िगर नहीं किया गया है।',
  NLSOpsSitesOpenTemplatesBtn: 'टेम्पलेट खोलें',
} satisfies NlsStringMap

export default hiStringsNls
